import React from "react";
import { useIntl } from "react-intl";
import { EmptyLabel } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
function TextListCell({ list }) {
  const { formatMessage } = useIntl();
  return list?.length ? list.map((i) => typeof i === "string" ? i : formatMessage(i))?.join(", ") : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" });
}
export {
  TextListCell
};
//# sourceMappingURL=TextListCell.js.map
